// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   memberships: [],
//   packages: [],
//   filteredMemberships: [],
//   filteredPackages: [],
//   packagePagination: {
//     page: 1,
//     limit: 10,
//     total: 0,
//   },
//   loading: false,
//   error: null,
//   pagination: {
//     page: 1,
//     limit: 10,
//     total: 0,
//   },
//   filters: {
//     search: '',
//     membershipType: 'serviceType',
//   },
//   services: [],
//   updatedMembershipData: {
//     membershipName: '',
//     membershipPrice: '',
//     duration: '',
//     rewardPointsOnPurchase: '',
//     servicesOffered: [{
//       service: '',
//       serviceName: '',
//       availableCount: 0,
//     }],
//   },
//   discountTypes: ['%', 'INR'],
//   updatedDiscountMembershipData: {
//     membershipName: '',
//     membershipPrice: '',
//     duration: '',
//     validTill: '',
//     rewardPointsOnPurchase: '',
//     discount: {
//       discountOnService: '',
//       serviceDiscountType: '%',
//       discountOnProduct: '',
//       productDiscountType: '%',
//       minBillAmount: '',
//     },
//   },
//   updatedPackageData: {
//     packageName: '',
//     price: '',
//     packageDuration: '',
//   },
//   selectedPackageId: null,
// };

// const applyFilters = (state) => {
//   const { memberships, packages, filters, pagination, packagePagination } = state;

//   let filteredMemberships = memberships.filter((item) => {
//     const isTypeMatch = item.membershipType === filters.membershipType;
//     const isSearchMatch = !filters.search ||
//       item.membershipName?.toLowerCase().includes(filters.search.toLowerCase());

//     return isTypeMatch && isSearchMatch;
//   });

//   let filteredPackages = packages.filter((item) => {
//     const isTypeMatch = filters.membershipType === 'packageType';
//     const isSearchMatch = !filters.search ||
//       item.packageName?.toLowerCase().includes(filters.search.toLowerCase());

//     return isTypeMatch && isSearchMatch;
//   });

//   const membershipsStartIndex = (pagination.page - 1) * pagination.limit;
//   const membershipsEndIndex = membershipsStartIndex + pagination.limit;
//   state.filteredMemberships = filteredMemberships.slice(membershipsStartIndex, membershipsEndIndex);
//   state.pagination.total = filteredMemberships.length;

//   const packagesStartIndex = (packagePagination.page - 1) * packagePagination.limit;
//   const packagesEndIndex = packagesStartIndex + packagePagination.limit;
//   state.filteredPackages = filteredPackages.slice(packagesStartIndex, packagesEndIndex);
//   state.packagePagination.total = filteredPackages.length;
// };

// const membershipSlice = createSlice({
//   name: 'membership',
//   initialState,
//   reducers: {
//     setMemberships: (state, action) => {
//       state.memberships = action.payload;
//       applyFilters(state);
//     },
//     setPackages: (state, action) => {
//       state.packages = action.payload;
//       applyFilters(state);
//     },
//     setLoading: (state, action) => {
//       state.loading = action.payload;
//     },
//     setPage: (state, action) => {
//       if (state.filters.membershipType === 'packageType') {
//         state.packagePagination.page = action.payload;
//       } else {
//         state.pagination.page = action.payload;
//       }
//       applyFilters(state);
//     },
//     setLimit: (state, action) => {
//       if (state.filters.membershipType === 'packageType') {
//         state.packagePagination.limit = action.payload;
//         state.packagePagination.page = 1;
//       } else {
//         state.pagination.limit = action.payload;
//         state.pagination.page = 1;
//       }
//       applyFilters(state);
//     },
//     setSearch: (state, action) => {
//       state.filters.search = action.payload;
//       state.pagination.page = 1;
//       state.packagePagination.page = 1;
//       applyFilters(state);
//     },
//     setMembershipType: (state, action) => {
//       state.filters.membershipType = action.payload;
//       state.pagination.page = 1;
//       state.packagePagination.page = 1;
//       applyFilters(state);
//     },
//     clearFilters: (state) => {
//       state.filters = initialState.filters;
//       state.pagination = initialState.pagination;
//       state.packagePagination = initialState.packagePagination;
//     },
//     updateMembershipInState: (state, action) => {
//       const updatedMembership = action.payload;
//       state.memberships = state.memberships.map(membership =>
//         membership._id === updatedMembership._id ? updatedMembership : membership
//       );
//       applyFilters(state);
//     },
//     removeMembershipFromState: (state, action) => {
//       const membershipId = action.payload;
//       state.memberships = state.memberships.filter(membership => membership._id !== membershipId);
//       applyFilters(state);
//     },
//     setUpdatedServiceMembershipData: (state, action) => {
//       const { field, value } = action.payload;
//       state.updatedMembershipData[field] = value;
//     },
//     setUpdatedServicesOffered: (state, action) => {
//       state.updatedMembershipData.servicesOffered = action.payload;
//     },
//     addServiceRow: (state) => {
//       const hasUnselectedService = state.updatedMembershipData.servicesOffered.some(
//         item => item.service === '' || item.availableCount <= 0
//       );

//       if (!hasUnselectedService) {
//         state.updatedMembershipData.servicesOffered.push({
//           service: '',
//           serviceName: '',
//           availableCount: 0,
//         });
//       } else {
//         state.error = 'Select a service and count for the existing row(s) before adding a new row.';
//       }
//     },
//     removeServiceRow: (state, action) => {
//       const index = action.payload;
//       state.updatedMembershipData.servicesOffered.splice(index, 1);
//     },
//     updateServiceRow: (state, action) => {
//       const { index, field, value } = action.payload;
//       if (state.updatedMembershipData.servicesOffered[index]) {
//         state.updatedMembershipData.servicesOffered[index][field] = value;
//       }
//     },
//     setServices: (state, action) => {
//       state.services = action.payload;
//     },
//     resetUpdatedServiceMembershipData: (state) => {
//       state.updatedMembershipData = initialState.updatedMembershipData;
//     },
//     setSelectedServiceMembership: (state, action) => {
//       const membership = action.payload;
//       const servicesOffered = membership.servicesOffered?.map(item => {
//         const serviceId = typeof item.service === 'object' ? item.service._id : item.service;
//         const serviceName = typeof item.service === 'object' ? item.service.serviceName : '';
        
//         return {
//           service: serviceId || '',
//           serviceName: serviceName || '',
//           availableCount: item.availableCount || 0
//         };
//       }) || [{ service: '', serviceName: '', availableCount: 0 }];

//       state.updatedMembershipData = {
//         ...initialState.updatedMembershipData,
//         membershipName: membership.membershipName || '',
//         membershipPrice: membership.membershipPrice || '',
//         duration: membership.duration || '',
//         rewardPointsOnPurchase: membership.rewardPointsOnPurchase || '',
//         servicesOffered
//       };
//       state.selectedMembershipId = membership._id;

//       if (membership.servicesOffered?.length > 0) {
//         state.updatedMembershipData.servicesOffered = servicesOffered;
//       }
//     },
//     setUpdatedDiscountMembershipData: (state, action) => {
//       const { field, value } = action.payload;
//       if (field.includes('discount.')) {
//         const discountField = field.split('.')[1];
//         state.updatedDiscountMembershipData.discount[discountField] = value;
//       } else {
//         state.updatedDiscountMembershipData[field] = value;
//       }
//     },
//     setSelectedDiscountMembership: (state, action) => {
//       const membership = action.payload;

//       // Check if 'duration' exists in membership
//       const hasDuration = membership.hasOwnProperty('duration');

//       state.updatedDiscountMembershipData = {
//         ...initialState.updatedDiscountMembershipData,
//         membershipName: membership.membershipName || '',
//         membershipPrice: membership.membershipPrice || '',
//         rewardPointsOnPurchase: membership.rewardPointsOnPurchase || '',
//         // Conditionally assign either 'duration' or 'validTill'
//         duration: hasDuration ? membership.duration : '',
//         validTill: !hasDuration && membership.validTill ? membership.validTill : '',
//         discount: {
//           ...initialState.updatedDiscountMembershipData.discount,
//           ...membership.discount
//         }
//       };

//       state.selectedDiscountMembershipId = membership._id;
//     },
//     resetUpdatedDiscountMembershipData: (state) => {
//       state.updatedDiscountMembershipData = initialState.updatedDiscountMembershipData;
//       state.selectedDiscountMembershipId = null;
//     },
//     updateDiscountType: (state, action) => {
//       const { field, value } = action.payload;
//       state.updatedDiscountMembershipData.discount[field] = value;
//     },
//     setUpdatedPackageData: (state, action) => {
//       const { field, value } = action.payload;
//       state.updatedPackageData[field] = value;
//     },
//     setSelectedPackage: (state, action) => {
//       const packageItem = action.payload;
//       state.updatedPackageData = {
//         packageName: packageItem.packageName || '',
//         price: packageItem.price || '',
//         packageDuration: packageItem.packageDuration || '',
//       };
//       state.selectedPackageId = packageItem._id;
//     },
//     resetUpdatedPackageData: (state) => {
//       state.updatedPackageData = initialState.updatedPackageData;
//       state.selectedPackageId = null;
//     },
//     updatePackageInState: (state, action) => {
//       const updatedPackage = action.payload;
//       state.packages = state.packages.map(pkg =>
//         pkg._id === updatedPackage._id ? updatedPackage : pkg
//       );
//       applyFilters(state);
//     },
//     removePackageFromState: (state, action) => {
//       const packageId = action.payload;
//       state.packages = state.packages.filter(pkg => pkg._id !== packageId);
//       applyFilters(state);
//     },
//   },
// });

// export const {
//   setMemberships,
//   setPackages,
//   setLoading,
//   setPage,
//   setLimit,
//   setSearch,
//   setMembershipType,
//   clearFilters,
//   setUpdatedServiceMembershipData,
//   setUpdatedServicesOffered,
//   addServiceRow,
//   removeServiceRow,
//   updateServiceRow,
//   setServices,
//   resetUpdatedServiceMembershipData,
//   setSelectedServiceMembership,
//   updateMembershipInState,
//   removeMembershipFromState,
//   setUpdatedDiscountMembershipData,
//   setSelectedDiscountMembership,
//   resetUpdatedDiscountMembershipData,
//   updateDiscountType,
//   setUpdatedPackageData,
//   setSelectedPackage,
//   resetUpdatedPackageData,
//   updatePackageInState,
//   removePackageFromState,
//   resetFilters
// } = membershipSlice.actions;

// export default membershipSlice.reducer;

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  memberships: [],
  packages: [],
  filteredMemberships: [],
  filteredPackages: [],
  packagePagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
  filters: {
    search: '',
    membershipType: 'serviceType',
  },
  services: [],
  updatedMembershipData: {
    membershipName: '',
    membershipPrice: '',
    duration: '',
    validTill: '',
    rewardPointsOnPurchase: '',
    taxStatus: 'noGst',
    // gst: 5,
    servicesOffered: [{
      service: '',
      serviceName: '',
      availableCount: 0,
    }],
  },
  discountTypes: ['%', 'INR'],
  updatedDiscountMembershipData: {
    membershipName: '',
    membershipPrice: '',
    duration: '',
    validTill: '',
    rewardPointsOnPurchase: '',
    taxStatus: 'noGst',
    // gst: 5,
    discount: {
      discountOnService: '',
      serviceDiscountType: '%',
      discountOnProduct: '',
      productDiscountType: '%',
      minBillAmount: '',
    },
  },
  updatedPackageData: {
    packageName: '',
    price: '',
    durationType: '',
    packageDuration: '',
    validTill: '',
    taxStatus: 'noGst',
    // gst: 5,
  },
  selectedPackageId: null,
};

const fuzzyMatch = (text, search) => {
  const cleanSearch = (search || '').trim();
  if (!cleanSearch) return true;

  const lowerText = text?.toLowerCase().replace(/\s/g, '');
  if (!lowerText) return false;

  const lowerSearch = cleanSearch.toLowerCase().replace(/\s/g, '');

  let textIndex = 0;
  let searchIndex = 0;
  while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
    if (lowerText[textIndex] === lowerSearch[searchIndex]) {
      searchIndex++;
    }
    textIndex++;
  }
  return searchIndex === lowerSearch.length;
};
const applyFilters = (state) => {
  const { memberships, packages, filters, pagination, packagePagination } = state;

  let filteredMemberships = memberships.filter((item) => {
    const isTypeMatch = item.membershipType === filters.membershipType;
        const isSearchMatch = fuzzyMatch(item.membershipName, filters.search);

    return isTypeMatch && isSearchMatch;
  });

  let filteredPackages = packages.filter((item) => {
    const isTypeMatch = filters.membershipType === 'packageType';
        const isSearchMatch = fuzzyMatch(item.packageName, filters.search);

    return isTypeMatch && isSearchMatch;
  });

  const membershipsStartIndex = (pagination.page - 1) * pagination.limit;
  const membershipsEndIndex = membershipsStartIndex + pagination.limit;
  state.filteredMemberships = filteredMemberships.slice(membershipsStartIndex, membershipsEndIndex);
  state.pagination.total = filteredMemberships.length;

  const packagesStartIndex = (packagePagination.page - 1) * packagePagination.limit;
  const packagesEndIndex = packagesStartIndex + packagePagination.limit;
  state.filteredPackages = filteredPackages.slice(packagesStartIndex, packagesEndIndex);
  state.packagePagination.total = filteredPackages.length;
};

const membershipSlice = createSlice({
  name: 'membership',
  initialState,
  reducers: {
    setMemberships: (state, action) => {
      state.memberships = action.payload;
      applyFilters(state);
    },
    setPackages: (state, action) => {
      state.packages = action.payload;
      applyFilters(state);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPage: (state, action) => {
      if (state.filters.membershipType === 'packageType') {
        state.packagePagination.page = action.payload;
      } else {
        state.pagination.page = action.payload;
      }
      applyFilters(state);
    },
    setLimit: (state, action) => {
      if (state.filters.membershipType === 'packageType') {
        state.packagePagination.limit = action.payload;
        state.packagePagination.page = 1;
      } else {
        state.pagination.limit = action.payload;
        state.pagination.page = 1;
      }
      applyFilters(state);
    },
    setSearch: (state, action) => {
      state.filters.search = action.payload;
      state.pagination.page = 1;
      state.packagePagination.page = 1;
      applyFilters(state);
    },
    setMembershipType: (state, action) => {
      state.filters.membershipType = action.payload;
      state.pagination.page = 1;
      state.packagePagination.page = 1;
      applyFilters(state);
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
      state.pagination = initialState.pagination;
      state.packagePagination = initialState.packagePagination;
    },
    updateMembershipInState: (state, action) => {
      const updatedMembership = action.payload;
      state.memberships = state.memberships.map(membership =>
        membership._id === updatedMembership._id ? updatedMembership : membership
      );
      applyFilters(state);
    },
    removeMembershipFromState: (state, action) => {
      const membershipId = action.payload;
      state.memberships = state.memberships.filter(membership => membership._id !== membershipId);
      applyFilters(state);
    },
    setUpdatedServiceMembershipData: (state, action) => {
      const { field, value } = action.payload;
      state.updatedMembershipData[field] = value;
    },
    setUpdatedServicesOffered: (state, action) => {
      state.updatedMembershipData.servicesOffered = action.payload;
    },
    addServiceRow: (state) => {
      const hasUnselectedService = state.updatedMembershipData.servicesOffered.some(
        item => item.service === '' || item.availableCount <= 0
      );

      if (!hasUnselectedService) {
        state.updatedMembershipData.servicesOffered.push({
          service: '',
          serviceName: '',
          availableCount: 0,
        });
      } else {
        state.error = 'Select a service and count for the existing row(s) before adding a new row.';
      }
    },
    removeServiceRow: (state, action) => {
      const index = action.payload;
      state.updatedMembershipData.servicesOffered.splice(index, 1);
    },
    updateServiceRow: (state, action) => {
      const { index, field, value } = action.payload;
      if (state.updatedMembershipData.servicesOffered[index]) {
        state.updatedMembershipData.servicesOffered[index][field] = value;
      }
    },
    setServices: (state, action) => {
      state.services = action.payload;
    },
    resetUpdatedServiceMembershipData: (state) => {
      state.updatedMembershipData = initialState.updatedMembershipData;
    },
    setSelectedServiceMembership: (state, action) => {
      const membership = action.payload;
       // Check if 'duration' exists in membership
      const hasDuration = membership.hasOwnProperty('duration');

      const servicesOffered = membership.servicesOffered?.map(item => {
        const serviceId = typeof item.service === 'object' ? item.service._id : item.service;
        const serviceName = typeof item.service === 'object' ? item.service.serviceName : '';
        
        return {
          service: serviceId || '',
          serviceName: serviceName || '',
          availableCount: item.availableCount || 0
        };
      }) || [{ service: '', serviceName: '', availableCount: 0 }];

      state.updatedMembershipData = {
        ...initialState.updatedMembershipData,
        membershipName: membership.membershipName || '',
        membershipPrice: membership.membershipPrice || '',
        duration: hasDuration ? membership.duration : '',
        validTill: !hasDuration && membership.validTill ? membership.validTill : '',
        rewardPointsOnPurchase: membership.rewardPointsOnPurchase || '',
        taxStatus: membership.taxStatus || 'noGst',
        // gst: membership.gst || 5,
        servicesOffered
      };
      state.selectedMembershipId = membership._id;

      if (membership.servicesOffered?.length > 0) {
        state.updatedMembershipData.servicesOffered = servicesOffered;
      }
    },
    setUpdatedDiscountMembershipData: (state, action) => {
      const { field, value } = action.payload;
      if (field.includes('discount.')) {
        const discountField = field.split('.')[1];
        state.updatedDiscountMembershipData.discount[discountField] = value;
      } else {
        state.updatedDiscountMembershipData[field] = value;
      }
    },
    setSelectedDiscountMembership: (state, action) => {
      const membership = action.payload;

      // Check if 'duration' exists in membership
      const hasDuration = membership.hasOwnProperty('duration');

      state.updatedDiscountMembershipData = {
        ...initialState.updatedDiscountMembershipData,
        membershipName: membership.membershipName || '',
        membershipPrice: membership.membershipPrice || '',
        rewardPointsOnPurchase: membership.rewardPointsOnPurchase || '',
        // Conditionally assign either 'duration' or 'validTill'
        duration: hasDuration ? membership.duration : '',
        validTill: !hasDuration && membership.validTill ? membership.validTill : '',
        taxStatus: membership.taxStatus || 'noGst',
        // gst: membership.gst || 5,
        discount: {
          ...initialState.updatedDiscountMembershipData.discount,
          ...membership.discount,
        }
      };

      state.selectedDiscountMembershipId = membership._id;
    },
    resetUpdatedDiscountMembershipData: (state) => {
      state.updatedDiscountMembershipData = initialState.updatedDiscountMembershipData;
      state.selectedDiscountMembershipId = null;
    },
    updateDiscountType: (state, action) => {
      const { field, value } = action.payload;
      state.updatedDiscountMembershipData.discount[field] = value;
    },
    setUpdatedPackageData: (state, action) => {
      const { field, value } = action.payload;
      state.updatedPackageData[field] = value;
    },
    // setSelectedPackage: (state, action) => {
    //   const packageItem = action.payload;
    //   state.updatedPackageData = {
    //     packageName: packageItem.packageName || '',
    //     price: packageItem.price || '',
    //     packageDuration: packageItem.packageDuration || '',
    //   };
    //   state.selectedPackageId = packageItem._id;
    // },
setSelectedPackage: (state, action) => {
  const pkg = action.payload;

  state.updatedPackageData = {
    packageName: pkg.packageName || '',
    price: pkg.price || '',
    durationType: pkg.packageDuration ? 'duration' : 'validTill',
    packageDuration: pkg.packageDuration || '',
    validTill: pkg.validTill || '',
    taxStatus: pkg.taxStatus || 'noGst',
    services: pkg.services || []  // ✅ Ensure services always included
  };

  state.selectedPackageId = pkg._id;
},


    resetUpdatedPackageData: (state) => {
      state.updatedPackageData = initialState.updatedPackageData;
      state.selectedPackageId = null;
    },
    updatePackageInState: (state, action) => {
      const updatedPackage = action.payload;
      state.packages = state.packages.map(pkg =>
        pkg._id === updatedPackage._id ? updatedPackage : pkg
      );
      applyFilters(state);
    },
    removePackageFromState: (state, action) => {
      const packageId = action.payload;
      state.packages = state.packages.filter(pkg => pkg._id !== packageId);
      applyFilters(state);
    },
  },
});

export const {
  setMemberships,
  setPackages,
  setLoading,
  setPage,
  setLimit,
  setSearch,
  setMembershipType,
  clearFilters,
  setUpdatedServiceMembershipData,
  setUpdatedServicesOffered,
  addServiceRow,
  removeServiceRow,
  updateServiceRow,
  setServices,
  resetUpdatedServiceMembershipData,
  setSelectedServiceMembership,
  updateMembershipInState,
  removeMembershipFromState,
  setUpdatedDiscountMembershipData,
  setSelectedDiscountMembership,
  resetUpdatedDiscountMembershipData,
  updateDiscountType,
  setUpdatedPackageData,
  setSelectedPackage,
  resetUpdatedPackageData,
  updatePackageInState,
  removePackageFromState,
  resetFilters
} = membershipSlice.actions;

export default membershipSlice.reducer;